import React from 'react';
import './HowItWorksSection.css'; // Import the component-specific styles

function HowItWorksSection() {
  return (
    // Converted HTML to JSX (class -> className)
    <section className="how-it-works-section">
      <div className="section-inner">
        <div className="section-header">
          <h2 className="section-title">How It Works</h2>
          <p className="section-subtitle">A seamless journey to connect with your faith.</p>
        </div>
        <div className="steps-grid">
          <div className="step">
            <div className="step-icon-wrapper">
              <span className="material-symbols-outlined step-icon">shopping_cart</span>
            </div>
            <h3 className="step-title">1. Place Order Online</h3>
            <p className="step-description">Select your desired puja and temple from our curated list.</p>
          </div>
          <div className="step">
            <div className="step-icon-wrapper">
              <span className="material-symbols-outlined step-icon">person_search</span>
            </div>
            <h3 className="step-title">2. We Contact You</h3>
            <p className="step-description">We'll get in touch to collect details like Name, Rasi, and Nakshatra.</p>
          </div>
          <div className="step">
            <div className="step-icon-wrapper">
              <span className="material-symbols-outlined step-icon">temple_hindu</span>
            </div>
            <h3 className="step-title">3. Puja is Performed</h3>
            <p className="step-description">Our representative performs the puja on your behalf at the temple.</p>
          </div>
          <div className="step">
            <div className="step-icon-wrapper">
              <span className="material-symbols-outlined step-icon">local_shipping</span>
            </div>
            <h3 className="step-title">4. Receive Prasad</h3>
            <p className="step-description">Prasad and a photo of the deity are couriered to your doorstep.</p>
          </div>
          <div className="step">
            <div className="step-icon-wrapper">
              <span className="material-symbols-outlined step-icon">chat</span>
            </div>
            <h3 className="step-title">5. Live Updates</h3>
            <p className="step-description">Get live updates and photos via WhatsApp for complete transparency.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HowItWorksSection;
